import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyInputDirective } from './currency-input/currency-input.directive';
import { DebounceClickDirective } from './debounce-click/debounce-click.directive';
import { ImagePlaceholderDirective } from './image-placeholder/image-placeholder.directive';
import { InfiniteScrollerDirective } from './infinite-scroll/infinite-scroll.directive';
import { NumericLocaleInputDirective } from './number-locale-input/number-locale-input.directive';
import { NumericInputDirective } from './numeric-input/numeric-input.directive';
import { PhoneNumberInputDirective } from './phone-number-input/phone-number-input.directive';
import { TimeInputDirective } from './time-input/time-input.directive';

@NgModule({
    imports: [CommonModule, CurrencyInputDirective,
        DebounceClickDirective,
        ImagePlaceholderDirective,
        InfiniteScrollerDirective,
        PhoneNumberInputDirective,
        TimeInputDirective,
        NumericInputDirective,
        NumericLocaleInputDirective],
    providers: [CurrencyPipe],
    exports: [
        CurrencyInputDirective,
        DebounceClickDirective,
        ImagePlaceholderDirective,
        InfiniteScrollerDirective,
        PhoneNumberInputDirective,
        TimeInputDirective,
        NumericInputDirective,
        NumericLocaleInputDirective
    ]
})
export class UzurvDirectivesModule {}
